<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells position="between">
        <h1 class="title">
          {{ sup_data.trade_name === sup_data.legal_name ? sup_data.trade_name : `${sup_data.trade_name} (${sup_data.legal_name})` }}
        </h1>
      </app-cells>
      <div class="info-cards">
        <div class="info-cards__card">
          <button class="info-cards__control" @click="onShowEditPopup">
            <img src="@/assets/img/edit-table-icon.svg" alt="">
          </button>
          <div class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full">
              <span>Type:</span><span>{{ sup_data.type?.name || '-' }}</span>
            </div>
          </div>
          <div class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full">
              <span>TIN:</span><span>{{ sup_data.tin || '-' }}</span>
            </div>
          </div>
          <div class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full">
              <span>VRN:</span><span>{{ sup_data.vrn || 'Not registered' }}</span>
            </div>
          </div>
          <div class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full">
              <span>Region:</span><span>{{ sup_data.region?.name || '-' }}</span>
            </div>
          </div>
        </div>
        <div class="info-cards__card">
          <div class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full">
              <span>Group:</span><span>{{ sup_data.group?.name || '-' }}</span>
            </div>
          </div>
          <div class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full">
              <span>Item:</span><span>{{ sup_data.transaction_item?.name_expense || '-' }}</span>
            </div>
          </div>
        </div>
      </div>
      <app-cells>
        <app-textarea
          v-model="sup_data.notes"
          rows="5"
          @change.native="onUpdateSupplier({ notes: sup_data.notes })"
          placeholder="Write a notes"
        />
      </app-cells>
      <app-tabs :tabs="tabs" />
      <transition name="fade" mode="out-in">
        <router-view
          @changeVerify="onUpdateSupplier({ verified: $event }, true)"
          :supplierData="sup_data"
          :paymentVerifiedLoader="payment_verified_loader"
        />
      </transition>
    </template>
    <modal
      name="edit"
      :width="700"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('edit')" class="popup__close" type="button"></button>
        <div class="popup__title">Edit supplier</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckForm">
            <app-grid>
              <template #item-1>
                <app-form-group label="Legal name" label-for="legal_name" required>
                  <app-input
                    v-model="form.legal_name"
                    id="legal_name"
                    placeholder="Legal name"
                    name="legal_name"
                    :error="$v.form.legal_name.$error"
                  />
                  <template #error>
                    <div v-if="$v.form.legal_name.$dirty && !$v.form.legal_name.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group label="Trade name" label-for="trade_name" required>
                  <app-input
                    v-model="form.trade_name"
                    id="trade_name"
                    placeholder="Trade name"
                    name="trade_name"
                    :error="$v.form.trade_name.$error"
                  />
                  <template #error>
                    <div v-if="$v.form.trade_name.$dirty && !$v.form.trade_name.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group label="Region">
                  <app-select
                    v-model="form.region"
                    :options="region_options"
                    placeholder="Region"
                  />
                </app-form-group>
                <app-form-group label="Group" required>
                  <app-select
                    v-model="form.group"
                    :options="suppliers_groups_options"
                    :clearable="false"
                    placeholder="Group"
                    :error="$v.form.group.$error"
                  />
                  <template #error>
                    <div v-if="$v.form.group.$dirty && !$v.form.group.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group label="Transaction item">
                  <app-select
                    v-model="form.transaction_item"
                    :options="transaction_items_options"
                    :reduce="item => item.id"
                    label="name_expense"
                    placeholder="Transaction item"
                  />
                </app-form-group>
              </template>
              <template #item-2>
                <app-form-group label="Type" required>
                  <app-select
                    v-model="form.type"
                    :options="suppliers_types_options"
                    :clearable="false"
                    label="name"
                    placeholder="Type"
                    :error="$v.form.type.$error"
                  />
                  <template #error>
                    <div v-if="$v.form.type.$dirty && !$v.form.type.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group v-if="form.type?.tin" label="TIN" label-for="tin" required>
                  <app-input
                    v-model="form.tin"
                    id="tin"
                    placeholder="TIN"
                    name="tin"
                    :error="$v.form.tin.$error"
                  />
                  <template #error>
                    <div v-if="$v.form.tin.$dirty && !$v.form.tin.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group v-if="form.type?.vat" label="VAT" class="form-group--center">
                  <app-checkbox
                    v-model="form.vat"
                    label="VAT registered"
                    style="height: 28px;align-items: flex-start"
                  />
                </app-form-group>
                <app-form-group v-if="form.vat" label="VRN" label-for="vrn" required>
                  <app-input
                    v-model="form.vrn"
                    id="vrn"
                    placeholder="VRN"
                    name="vrn"
                    :error="$v.form.vrn.$error"
                  />
                  <template #error>
                    <div v-if="$v.form.vrn.$dirty && !$v.form.vrn.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group label="Territory" required class="form-group--mh">
                  <app-cells :indent="false">
                    <app-radio
                      v-for="radio of tax_zones_options"
                      :key="radio.name"
                      v-model="form.territory"
                      :value="radio.code"
                      name="tax_zones"
                      :checked="form.territory === radio.code"
                    >
                      <template #label>{{ radio.name }}</template>
                    </app-radio>
                  </app-cells>
                  <template #error>
                    <div v-if="$v.form.territory.$dirty && !$v.form.territory.required">Required field</div>
                  </template>
                </app-form-group>
              </template>
            </app-grid>
            <app-cells :indent="false" position="center">
              <app-button :disabled="$v.form.$error" type="submit" ref="submit">Save supplier</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>

import {
  getAdministrativeSupplierFull,
  getAdministrativeSuppliersGroups,
  getAdministrativeSuppliersTypes,
  getFinanceTaxZones,
  getFinanceTransactionsItemsList,
  getLocationRegions,
  patchAdministrativeSupplierFull,
} from '@/http'
import { required, requiredIf } from 'vuelidate/lib/validators'
import AppTabs from '@/components/AppTabs.vue'

export default {
  name: 'SuppliersDetail',
  components: { AppTabs },
  data() {
    return {
      is_loaded: false,
      form: {},
      sup_data: {},
      suppliers_groups_options: [],
      suppliers_types_options: [],
      region_options: [],
      tax_zones_options: [],
      transaction_items_options: [],
      tabs: [
        { name: 'administrative-suppliers-detail-purchases', label: 'Purchases' },
        { name: 'administrative-suppliers-detail-statement', label: 'Statement' },
        { name: 'administrative-suppliers-detail-payment-methods', label: 'Payment methods' },
        { name: 'administrative-suppliers-detail-contacts', label: 'Contacts' },
      ],
      payment_verified_loader: false,
    }
  },
  validations: {
    form: {
      type: { required },
      group: { required },
      legal_name: { required },
      trade_name: { required },
      territory: { required },
      tin: {
        required: requiredIf(function() {
          return this.form.type?.tin
        })
      },
      vrn: {
        required: requiredIf(function() {
          return this.form.vat
        })
      },
    },
  },
  computed: {
    is_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
  },
  created() {
    this.getSupplierData()
    getAdministrativeSuppliersGroups().then(res => { this.suppliers_groups_options = res.data })
    getAdministrativeSuppliersTypes().then(res => { this.suppliers_types_options = res.data })
    getLocationRegions().then(res => { this.region_options = res.data })
    getFinanceTaxZones().then(res => { this.tax_zones_options = res.data })
    getFinanceTransactionsItemsList({expense: true}).then(res => { this.transaction_items_options = res.data })
  },
  methods: {
    onUpdateSupplier(data, need_loader) {
      if (need_loader) this.payment_verified_loader = true
      patchAdministrativeSupplierFull(Number(this.$route.params.id), data)
        .then(() => {
          this.getSupplierData()
          this.$notify({
            type: 'success',
            title: 'Data saved',
          })
        })
    },
    onShowEditPopup() {
      this.$modal.show('edit')
    },
    getSupplierData() {
      getAdministrativeSupplierFull(this.$route.params.id)
        .then(res => {
          this.form = { ...res.data, territory: res.data.territory.code, transaction_item: res.data.transaction_item?.id || null }
          this.sup_data = res.data
          this.is_loaded = true
          this.payment_verified_loader = false
        })
    },
    onCheckForm() {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.submit.preload = true
      const data = { ...this.form }
      data.group = data.group.id
      data.type = data.type.code
      data.region = data.region?.id || null
      data.verified_by = data.verified_by?.id || null
      if (!data.vat) data.vrn = null
      patchAdministrativeSupplierFull(this.$route.params.id, data)
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Supplier saved',
          })
          this.getSupplierData()
          this.$modal.hide('edit')
        })
        .catch(() => { this.$refs.submit.preload = false })
    },
  }
}
</script>

<style scoped lang="sass">
.supplier-form
  max-width: 500px
</style>
